import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { ViewTitle } from '../components/reusable'
import { Page } from '../ui'
import { ManualAddClientView } from '../components/views/manualAddClientView'

function ManualAddClient() {
    return (
        <div className="manualAddClient">
            <Sidebar />
            <MainView>
                <Page>
                    <ViewTitle text={'Add Client'} />
                    <ManualAddClientView />
                </Page>
            </MainView>
        </div>
    )
}

export default ManualAddClient
